import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { SR_API_ACTION_UTILITY_PARTNER_UPDATE_PROFILE } from 'api/utilityActionTypes';

import { UTILITY_USER_ROLE_ADMIN, UTILITY_USER_ROLE_PARTNER } from 'common/utility/userRoles';

import { SCREEN_ID_UTILITY_PARTNER_SETTINGS_TEAM } from 'client/constants/screenIds';

import requestUtilityApi from 'client/actions/requestUtilityApi';
import UtilityPartnerActions from 'client/actions/UtilityPartner';
import UtilityPartnerGroupActions from 'client/actions/UtilityPartnerGroup';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import branch from 'client/core/branch';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrUtilityProfitPartnerUsersDataTable from 'client/components/SrUtilityProfitPartnerUsersDataTable/SrUtilityProfitPartnerUsersDataTable';

@withTransitionHook
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN, UTILITY_USER_ROLE_PARTNER],
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_UTILITY_PARTNER_SETTINGS_TEAM)
@withScrollToTop
@branch(({ match }) => ({
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
  utilityUser: ['utilityUser'],
}))
@branch(({ utilityPartner }) => {
  if (utilityPartner?.utilityPartnerGroupId) {
    return {
      utilityPartnerList: [
        'utilityPartners',
        'byPartnerGroupId',
        utilityPartner.utilityPartnerGroupId,
      ],
    };
  }

  return {};
})
class UtilityPartnerSettingsTeamManagementPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Profile',
  });

  static fetchData(match, inject) {
    const { partnerSlug } = match.params;
    const utilityPartner = inject.state.get(['utilityPartners', 'bySlug', partnerSlug]);

    const promises = [];

    if (!utilityPartner) {
      promises.push(
        UtilityPartnerActions.getBySlug(inject, {
          slug: partnerSlug,
        }),
      );
    }

    return Promise.all(promises).then(() => {
      const utilityPartner = inject.state.get(['utilityPartners', 'bySlug', partnerSlug]);

      if (utilityPartner?.utilityPartnerGroupId) {
        return UtilityPartnerGroupActions.getPartnersInGroup(inject, {
          utilityPartnerGroupId: utilityPartner.utilityPartnerGroupId,
        });
      }
    });
  }

  static propTypes = {
    utilityPartner: PropTypes.object,
    isTransitioning: PropTypes.bool,
  };

  _onSubmitForm = (formValues) => {
    const { utilityPartner, dispatch, history } = this.props;

    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_PARTNER_UPDATE_PROFILE,
      payload: {
        utilityPartnerId: utilityPartner.id,
        updates: formValues,
      },
    }).then(() => {
      dispatch(UtilityPartnerActions.getBySlug, {
        slug: utilityPartner.slug,
        forceRefresh: true,
      }).then(() => {
        history.push(`/utility-profit/${utilityPartner.slug}/settings`);
      });
    });
  };

  render() {
    const { utilityPartner, utilityUser, utilityPartnerList, isTransitioning } = this.props;

    if (isTransitioning) {
      return null;
    }

    if (!utilityPartner) {
      return <Redirect to="/" />;
    }

    return (
      <SrPartnerPageV2
        backUrl={`/utility-profit/${utilityPartner.slug}/settings`}
        navbarImage={utilityPartner.logoUrl}
        navbarTitle={utilityPartner.name}
      >
        <SrUtilityProfitPartnerUsersDataTable
          utilityPartner={utilityPartner}
          utilityUser={utilityUser}
          utilityPartnerList={utilityPartnerList || []}
        />
      </SrPartnerPageV2>
    );
  }
}

UtilityPartnerSettingsTeamManagementPage.displayName = 'UtilityPartnerSettingsTeamManagementPage';

export default UtilityPartnerSettingsTeamManagementPage;
